import styled from "styled-components";

export const WalletBalance = ({ balance }: IProps) => {
	if (!balance) {
		return <></>;
	}
	return (
		<StyledComponent>
			<div className="title">Остаток на кошельках</div>
			<div className="network">
				<div className="name">Ethereum</div>
				<div className="balance">
					{balance.ethereum.amount} USDT / {balance.ethereum.eth} ETH
				</div>
			</div>
			<div className="network">
				<div className="name">Tron</div>
				<div className="balance">
					{balance.tron.amount} USDT / {balance.tron.trx} TRX
				</div>
			</div>
		</StyledComponent>
	);
};

interface IProps {
	balance?: IWalletsBalance;
}
interface IWalletsBalance {
	[key: string]: {
		amount: number;
		wallet_type: string;
		trx: number;
		eth: number;
	};
}

const StyledComponent = styled.div`
	& .network {
		display: flex;
		padding: 0.5rem 0;
		gap: 0.5rem;

		& > div {
			flex-grow: 1;
		}

		& .balance {
			text-align: end;
		}
	}
`;
